module.exports = __webpack_public_path__ + "static/media/backward-icon.f3b497e9.svg";